<template>
  <div>
    <loading-cube v-if="loading" :loading-message="'WORKERS TO ASSIGN'"></loading-cube>
    <ValidationObserver ref="assignAllWorkersForm" slim v-else>
      <form role="form" @submit.prevent="assign_all_workers" class="row clearfix">

        <div class="col-12">
          <b-card header="Job Order Information" header-tag="h4" body-class="mb-3 record_card_body">
            <div class="row">
              <div class="col-lg-4 form-group">
                <label class="form-label" for="order_job_company">Company</label>
                <input type="text" v-model="company.company_name" class="form-input disabled" disabled="disabled"
                       id="order_job_company" name="order_job_company" placeholder="Order job company">
              </div>
              <div class="col-lg-4 form-group">
                <div class="pa_box" :class="[company.payroll_pa_insurance ? 'has_pa' : '']">
                  <span v-if="company.rel_payment_process_info.payroll_pa_insurance">COMPANY HAS PA INSURANCE</span>
                  <span v-else>COMPANY DOES NOT HAVE PA INSURANCE</span>
                </div>
              </div>
              <div class="col-lg-4 form-group">
                <label class="form-label" for="order_job_ref">Order Ref</label>
                <input type="text" v-model="$store.state.assignments.all_assignment.order_job.order_ref" class="form-input disabled" disabled="disabled"
                       id="order_job_ref" name="order_job_ref" placeholder="Order ref">
              </div>
              <div class="col-lg-4 form-group">
                <label class="form-label" for="order_job_type">Order Type</label>
                <input type="text" v-model="$store.state.assignments.all_assignment.order_job.order.order_type" class="form-input disabled" disabled="disabled"
                       id="order_job_type" name="order_job_type" placeholder="Order type">
              </div>
              <div class="col-lg-8 form-group">
                <label class="form-label" for="order_job_location">Order Location</label>
                <input type="text" v-model="$store.state.assignments.all_assignment.order_job.rel_order_location.job_address_full" class="form-input disabled" disabled="disabled"
                       id="order_job_location" name="order_job_location" placeholder="Order location">
              </div>

              <div class="col-12">
                <hr>
              </div>

              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Start Date" tag="div" class="col-lg-4">
                <label class="form-label" for="start_date">Start Date</label>
                <datepicker v-model="order_start_date" id="start_date" name="start_date"
                            :input-class="['date-input', 'requiredField']"
                            :format="dateFormat" :clear-button="true" :disabledDates="start_date_disabled" clear-button-icon="far fa-calendar-times"
                            @input="select_start_date" :use-utc="true"></datepicker>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>

              <ValidationProvider rules="required" v-slot="{errors, classes}" name="End Date" tag="div" class="col-lg-4">
                <label class="form-label" for="end_date">End Date</label>
                <datepicker v-model="order_end_date" id="end_date" name="end_date"
                            :input-class="['date-input', 'requiredField']"
                            :format="dateFormat" :clear-button="true" :disabledDates="end_date_disabled" clear-button-icon="far fa-calendar-times"
                            @input="select_end_date" :use-utc="true"></datepicker>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>

              <div class="col-lg-4 form-group">
                <button class="btn orcaBtn warning w-100 sm_btn mt-2" @click.prevent="set_all_price">Set all to price</button>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col-12">
          <div class="row">

            <div class="col-12" v-for="(worker, index) in workers" :key="index">
              <div class="assign_worker">
                <div class="row">
                  <div class="col-lg-4">
                    <h3 class="mb-0">{{ worker.full_name }}</h3>
                    <h5 class="b3_color">{{ worker.job_title }}</h5>
                    <div class="pa_box" :class="[worker.pa_insurance ? 'has_pa' : '']">
                      <span v-if="worker.pa_insurance">HAS PA INSURANCE</span>
                      <span v-else>NO PA INSURANCE</span>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <!-- Rate -->
                      <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Rate-' + index"
                                          tag="div" class="form-group col-12">
                        <label class="form-label" :for="'rate_' + index">Rate</label>
                        <multiselect v-model="worker.rate" :id="'rate_' + index" :class="[classes, 'requiredField']" :name="'rate_' + index" placeholder=""
                                     :options="ms_opts.rates" :custom-label="rate_label"></multiselect>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                      <!-- start date -->
                      <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Start Date ' + index" tag="div" class="col-lg-6">
                        <label class="form-label" :for="'start_date_' + index">Start Date</label>
                        <datepicker v-model="worker.start_date" :id="'start_date_' + index" :name="'start_date_' + index"
                                    :input-class="['date-input', 'requiredField']"
                                    :format="dateFormat" :clear-button="true" :disabledDates="worker.start_date_disabled" clear-button-icon="far fa-calendar-times"
                                    @input="select_worker_start_date($event, index)" :use-utc="true"></datepicker>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                      <!-- end date -->
                      <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'End Date ' + index" tag="div" class="col-lg-6">
                        <label class="form-label" :for="'end_date_' + index">End Date</label>
                        <datepicker v-model="worker.end_date" :id="'end_date_' + index" :name="'end_date_' + index"
                                    :input-class="['date-input', 'requiredField']"
                                    :format="dateFormat" :clear-button="true" :disabledDates="worker.end_date_disabled" clear-button-icon="far fa-calendar-times"
                                    @input="select_worker_end_date($event, index)" :use-utc="true"></datepicker>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <h4 class="w_ref">{{ worker.worker_ref }}</h4>
                    <div class="w_remove">
                      <button class="btn orcaBtn sm_btn danger" @click.prevent="remove_worker(index)"><i class="fas fa-times"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <b-card header="Assignment confirmation" header-tag="h4" body-class="mb-3 record_card_body">

                <div class="row form-group">
                  <label class="col-md-8 cardLabel" for="send_ass_email">Send Assignment Email</label>
                  <div class="col-md-4">
                    <bootstrap-toggle v-model="send_ass_email" name="send_ass_email" id="send_ass_email" :options="{ on: 'Yes', off: 'No' }"/>
                  </div>
                </div>

            <div class="row">
              <div class="col-md-4 offset-md-8">
                <button class="btn orcaBtn w-100" @click.prevent="assign_all_workers" :disabled="saving">
                  <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving Assignments ...</span>
                  <span v-else>Assign & Send Emails</span>
                </button>
              </div>
            </div>
          </b-card>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";
import BootstrapToggle from "vue-bootstrap-toggle";
import loadingCube from "loaders/record_loader";
import Vue from "vue";

export default {
  name: "order_assign_all",
  components: {
    Multiselect,
    Datepicker,
    BootstrapToggle,
    loadingCube
  },
  data() {
    return {
      loading: true,
      workers: [],
      company: {},
      // order level start and end dates - declares in before mount for non-reactivity
      order_start_date: null,
      order_end_date: null,
      // order level disabled start and end dates
      start_date_disabled: {
        to: "",
        from: "",
      },
      end_date_disabled: {
        to: "",
        from: "",
      },
      // multiselect options
      ms_opts: {
        rates: []
      },
      // assignment email and confirmation
      send_ass_email: true,
      saving: false
    }
  },
  beforeMount() {
    let company_id = this.$store.state.assignments.all_assignment.company_id,
        order_job_id = this.$store.state.assignments.all_assignment.order_job_id,
        order_job = this.$store.state.assignments.all_assignment.order_job
    // get company relating to the order_job
    axios.get(this.crmApiPath + 'company/' + company_id).then(company => {
      this.company = company.data;
      // set start and end dates for order level
      this.order_start_date = this.$moment.utc().format('YYYY-MM-DD')
      this.order_end_date = order_job.rel_order_position.end_date
      /*
       * set disabled date (to) for order level
       * check if there has been any timesheet submission for the client
       */
      if (order_job.latest_submitted_ts_record !== null) {
        // disable start date to the start date of order
        this.start_date_disabled.to = new Date(this.$moment.utc(order_job.latest_submitted_ts_record.for_work_end_week_date)
                                                   .day(order_job.order.company.rel_payment_process_info.pay_week_start_day)
                                                   .subtract(7, 'days'))
        // disable end date to day after start date of order
        this.end_date_disabled.to = new Date(this.$moment.utc(order_job.latest_submitted_ts_record.for_work_end_week_date)
                                                 .day(order_job.order.company.rel_payment_process_info.pay_week_start_day)
                                                 .add(1, 'days'));
      }
      else {
        // check if there is an open timesheet week
        if (order_job.earliest_open_ts_record !== null) {
          // disable start date to the start date of order
          this.start_date_disabled.to = new Date(this.$moment.utc(order_job.earliest_open_ts_record.for_work_end_week_date)
                                                     .day(order_job.order.company.rel_payment_process_info.pay_week_start_day)
                                                     .subtract(7, 'days'));
          // disable end date to day after start date of order
          this.end_date_disabled.to = new Date(this.$moment.utc(order_job.earliest_open_ts_record.for_work_end_week_date)
                                                   .day(order_job.order.company.rel_payment_process_info.pay_week_start_day)
                                                   .add(1, 'days'));
        }
        else {
          // disable start date to the start date of order
          this.start_date_disabled.to = new Date(this.$moment.utc(order_job.rel_order_position.start_date)
                                                     .day(order_job.order.company.rel_payment_process_info.pay_week_start_day)
                                                     .subtract(7, 'days'));
          // disable end date to day after start date of order
          this.end_date_disabled.to = new Date(this.$moment.utc(order_job.rel_order_position.start_date)
                                                   .day(order_job.order.company.rel_payment_process_info.pay_week_start_day)
                                                   .add(1, 'days'));

        }
      }
      // set disabled date (from) for order level (end of order job)
      this.start_date_disabled.from = new Date(this.$moment.utc(order_job.rel_order_position.end_date));
      this.end_date_disabled.from = new Date(this.$moment.utc(order_job.rel_order_position.end_date));

      // get all workers to assign to the order from the companies current CCO worker assignments
      axios.get(this.crmApiPath + 'order/job/all_workers_to_assign/' + company_id + '/' + order_job_id)
           .then(workers => {
             this.workers = workers.data
             // populate rates from order
             this.ms_opts.rates = order_job.rel_order_position_rates
             // add in additional rates missing from the order to assign all workers
             workers.data.forEach(w => {
               // set start and end dates on each worker
               w.start_date = this.$moment.utc().format('YYYY-MM-DD')
               w.end_date = order_job.rel_order_position.end_date
               // disabled dates
               w.start_date_disabled.to = this.start_date_disabled.to
               w.start_date_disabled.from = new Date(this.$moment.utc(order_job.rel_order_position.end_date))
               w.end_date_disabled.to = this.end_date_disabled.to
               w.end_date_disabled.from = new Date(this.$moment.utc(order_job.rel_order_position.end_date))
               // if rates array doesn't contain the rate for the worker - add it
               if (!this.ms_opts.rates.some(r => r.id === w.assignment.position_rate_id)) {
                 this.ms_opts.rates.push(w.assignment_record.position_rate)
               }
             })
             // if price doesn't exist in rate list
             if (!this.ms_opts.rates.some(r => r.pay_type === "Price")) {
               // add price rate to options
               this.ms_opts.rates.push({
                 "id": null,
                 "order_job_id": null,
                 "rate_type": "Basic",
                 "pay_type": "Price",
                 "pay_amount": 1,
                 "admin_fee_type": this.company.rel_payment_process_info.fee_margin_type,
                 "admin_fee_amount": this.company.rel_payment_process_info.fee_margin_amount,
                 "retention_percentage": 5,
                 "deleted_at": null,
                 "created_at": this.$moment.utc().format('YYYY-MM-DD'),
                 "updated_at": this.$moment.utc().format('YYYY-MM-DD'),
               })
             }

             this.loading = false
           })
    })
  },
  methods: {
    /**
     * Date Format for datepicker
     * @param date
     * @returns {string}
     */
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    /**
     * Order level Select action for start date on datepicker
     * @param selected_start_date
     */
    select_start_date(selected_start_date) {
      if (selected_start_date != null) {
        this.order_start_date = this.$moment.utc(selected_start_date).format('YYYY-MM-DD');
      }
    },
    /**
     * Order level Select action for end date on datepicker
     * @param selected_end_date
     */
    select_end_date(selected_end_date) {
      if (selected_end_date != null) {
        this.order_end_date = this.$moment.utc(selected_end_date).format('YYYY-MM-DD');
      }
    },

    /**
     * Set all workers to price work rate (with pop-up confirm)
     */
    set_all_price() {
      // pop up to confirm action
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Set all workers to Price rate</div>' +
            '<div class="snotifyToast__body">' +
            'Confiirm setting all workers to price work rate.' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Set rates', action: (toast) => {
              // get price rate object
              let price_rate = this.ms_opts.rates.find((r => r.pay_type === "Price"))
              // loop through workers and set rate = price
              this.workers.forEach(w => {
                w.rate = price_rate
              })
              this.$snotify.remove(toast.id);
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },

    /**
     * Individual worker level Select action for start date on datepicker
     * @param date
     * @param worker_index
     */
    select_worker_start_date(date, worker_index) {
      if (date != null) {
        this.workers[worker_index].start_date = this.$moment.utc(date).format('YYYY-MM-DD');
      }
    },
    /**
     * Individual worker level Select action for end date on datepicker
     * @param date
     * @param worker_index
     */
    select_worker_end_date(date, worker_index) {
      if (date != null) {
        this.workers[worker_index].end_date = this.$moment.utc(date).format('YYYY-MM-DD');
      }
    },

    /**
     * Label showing rate values in worker assignment multiselect for rates
     *
     * @param pay_type
     * @param rate_type
     * @param pay_amount
     * @param admin_fee_type
     * @param admin_fee_amount
     * @returns {string}
     */
    rate_label({pay_type, rate_type, pay_amount, admin_fee_type, admin_fee_amount}) {
      let a_fee = '';
      if (admin_fee_type === '£ (Pound)') {
        a_fee = this.$options.filters.currency(admin_fee_amount);
      }
      if (admin_fee_type === '% (Percentage)') {
        a_fee = this.$options.filters.percentage(admin_fee_amount);
      }
      let p_amount = this.$options.filters.currency(pay_amount);

      return `[${rate_type} : ${pay_type}] ` + p_amount + ` - [Admin Fee : ` + a_fee + `]`;
    },

    /**
     * Remove worker from assignments list
     *
     * @param worker_index
     */
    remove_worker(worker_index) {
      let worker = this.workers[worker_index]
      // pop up to confirm action
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Remove worker from assignment list</div>' +
            '<div class="snotifyToast__body">' +
            'Confiirm removal of ' + worker.full_name + '.' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Set rates', action: (toast) => {
              // remove worker from array
              this.workers.splice(worker_index, 1)
              this.$snotify.remove(toast.id);
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },

    /* assign submission */
    assign_all_workers() {
      this.saving = true;
      this.$refs.assignAllWorkersForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.assignAllWorkersForm);
          setTimeout(() => {
            this.$nextTick(() => this.saving = false)
          }, 200)
        }
        else {
          // send all workers to backend to assign and send email if required
          axios.post(this.crmApiPath + 'assignments/assign_all_workers', {
            workers: this.workers,
            send_ass_email: this.send_ass_email,
            order_job_id: this.$store.state.assignments.all_assignment.order_job_id,
            order_job: this.$store.state.assignments.all_assignment.order_job,
            company_id: this.company.id,
            log_by_id: this.$store.state.auth.me.id
          }).then(() => {
            this.$store.commit('CURRENT_ORDER_ID', this.$store.state.assignments.all_assignment.order_job_id);
            this.$store.commit('SET_ORDER_TAB_INDEX', 0);
            this.$nextTick(() => {
              this.$bus.$emit('assignments::reload', {action: true});
              this.$tabs.close({
                path: this.$router.currentRoute.fullPath,
                to: '/order/view'
              });
              this.$tabs.refresh('/order/view', true)
            });
          })
        }
      });
    }
  },
  watch: {
    /**
     * Watch order level start date for change of date value
     * @param date
     */
    'order_start_date'(date) {
      let order_job = this.$store.state.assignments.all_assignment.order_job
      // if there is no date selected
      if (date === null) {
        this.start_date_disabled.from = new Date(this.$moment.utc(order_job.rel_order_position.end_date).add(1, 'days'));
      }
      else {
        this.start_date_disabled.from = new Date(this.$moment.utc(order_job.rel_order_position.end_date));
        // set start date for all workers
        this.workers.forEach(w => {
          w.start_date = new Date(this.$moment.utc(date))
        })
      }
      // disable the order level end date "to" to the start date selected.
      this.end_date_disabled.to = new Date(this.$moment.utc(date));
    },
    /**
     * Watch order level end date for change of date value
     * @param date
     */
    'order_end_date'(date) {
      let order_job = this.$store.state.assignments.all_assignment.order_job
      // if there is no date selected
      if (date === null) {
        this.end_date_disabled.from = new Date(this.$moment.utc(order_job.rel_order_position.end_date).add(1, 'days'));
      }
      else {
        this.end_date_disabled.from = new Date(this.$moment.utc(order_job.rel_order_position.end_date));
        // set start date for all workers
        this.workers.forEach(w => {
          w.end_date = new Date(this.$moment.utc(date))
        })
      }
    },
  }
}
</script>

<style scoped lang="scss">
.pa_box {
  text-align:    center;
  padding:       5px;
  background:    $red;
  color:         $white;
  margin-bottom: 10px;

  &.has_pa {
    background: $green;
  }
}

.assign_worker {
  background:    $card_background;
  padding:       20px;
  margin-bottom: 20px;
  border-radius: $border-radius;

  .w_name, .w_ref, .w_remove {
    display:        inline-block;
    vertical-align: top;
  }

  .w_name {
    width: calc(100% - 150px);
  }

  .w_ref {
    width:      105px;
    text-align: right;
    margin-top: 4px;
  }

  .w_remove {
    width:      50px;
    text-align: right;
  }
}
</style>
